var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-textarea"},[_c('textarea',{ref:"textArea",attrs:{"maxlength":_vm.maxlength},domProps:{"value":_vm.value},on:{"input":_vm.inputHandle}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7d96218","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomTextarea/CustomTextarea.vue
// module id = null
// module chunks = 